"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const enums_1 = require("./enums");
const utils_1 = require("./utils");
const getHeaders = (options = {}) => {
    const token = utils_1.getCookie(enums_1.CookiesType.token);
    const defaultHeaders = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
    };
    if ("headers" in options) {
        return Object.assign(Object.assign({}, defaultHeaders), options.headers);
    }
    else {
        return defaultHeaders;
    }
};
function getSnakedBody(body) {
    const snakedBody = Object.keys(body).reduce((acc, key) => {
        const currentItem = body[key];
        const isObject = typeof currentItem === "object" &&
            !Array.isArray(currentItem) &&
            currentItem != null;
        const value = isObject
            ? getSnakedBody(currentItem)
            : currentItem;
        acc[utils_1.getSnakeFromCamel(key)] = value;
        return acc;
    }, {});
    return snakedBody;
}
const { REACT_APP_API } = process.env;
exports.api = (path, options = {}) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const endpoint = /http/.test(path) ? path : `${REACT_APP_API}/${path}`;
    const headers = getHeaders(options);
    const res = yield fetch(endpoint, Object.assign(Object.assign({ headers, method: "GET" }, options), (options.body && {
        body: JSON.stringify(options.noSnakeBody === true ? options.body : getSnakedBody(options.body)),
    })));
    if (res.ok) {
        return res.json();
    }
    throw (yield ((_a = res) === null || _a === void 0 ? void 0 : _a.json())) || res;
});
//# sourceMappingURL=api.js.map